import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

import { subscribeErrors } from './errorBus'

/**
 * Bridges the error bus to Datadog RUM + Logs — the only module (besides
 * DataDog.tsx) that imports the Datadog SDKs, so the rest of the app stays
 * provider-agnostic. Both transports sit behind the bus throttle; there is no
 * unthrottled SDK auto-forwarding.
 *
 * Call once after the SDKs init and keep the returned unsubscribe for cleanup.
 * A throwing transport is swallowed so it can never re-enter `emitError`.
 */
export const connectDatadogErrorForwarder = (): (() => void) =>
  subscribeErrors(({ message, error, source, context }) => {
    try {
      datadogRum.addError(error ?? new Error(message), { source, ...context })
      datadogLogs.logger.error(message, { source, ...context }, error)
    } catch {
      // A forwarding failure must never propagate back into the bus.
    }
  })
